import React from "react";
import { VERIFY_STEPS_ARRAY } from "@constants/commonConstants";
import { useLoanRouteController } from "@hooks/useLoanRouteController";
import { createVerifyStepNavigator, verifyThankYouNavigation } from "@containers/Verify/routing/navigators";
import { useSelector } from "react-redux";


const pageNavigators = VERIFY_STEPS_ARRAY.map(({fullPath, stepName}) =>
  createVerifyStepNavigator(fullPath, stepName));

const navigators = [
  verifyThankYouNavigation,
  ...pageNavigators
];

export const VerifyRouteController = () => {
  const verifyState = useSelector(state => state.verify);
  useLoanRouteController(navigators, verifyState);

  return <>{/* Left intentionally blank */}</>
};

export const __TEST__ = {
  navigators,
}